import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

import logo from './assets/logo_antoo.png';
import tiktokLogo from './assets/tik-tok.png';
import instagramLogo from './assets/instagram.png';
import linkedinLogo from './assets/linkedin.png';
import incubateurLogo from './assets/incub_logo.jpg';
import downArrow from './assets/fleche-bas.png';
import epitechLogo from './assets/Epitech-logo.png';
import neomaLogo from './assets/Neoma-logo.png';
import CYUniversityLogo from './assets/CY-uni-logo.png';
import AboutUsStats from './assets/section-about-stats.png';
import SolutionImage from './assets/appercu-produit.png';
import SachaImage from './assets/sacha.jpg';
import BenjiImage from './assets/benji.jpg';
import MaxenceImage from './assets/maxence.jpeg';
import menuIcon from './assets/menu-burger.png';

import styles from './Home.module.css';

const Step = ({ number, active }) => {
  return (
    <div className={`${styles.step} ${active ? styles.active : ''}`}>
      <div className={styles.circle}>{number}</div>
    </div>
  );
};

const ProgressBar = ({ steps }) => {
  return (
    <div className={styles['progress-bar']}>
      {steps.map((step, index) => (
        <div key={index} className={`${styles.step} ${step.active ? styles.active : ''}`}>
          <div className={styles.circle}>{index + 1}</div>
          <div className={styles['step-text']}>{step.text}</div>
        </div>
      ))}
    </div>
  );
};

function App() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleButtonClick = () => {
    window.location.href = '/join-us';
  };

  const steps = [
    { text: 'Birth of Antoo', description: "The birth lol", active: true },
    { text: 'Establishment of strategic partnerships', description: "The birth lol", active: true },
    { text: 'Official launch of the application', description: "The birth lol", active: false },
    { text: 'Communication campaign', description: "The birth lol", active: false },
    { text: 'Continuous improvement', description: "The birth lol", active: false },
    { text: 'International expansion', description: "The birth lol", active: false },
  ];

  return (
    <div className={styles.App}>
      <Helmet>
      <title>Antoo - Find the ideal partner for your projects</title>
      <meta name="description" content="Avec Antoo, trouvez le partenaire idéal pour transformer vos idées en succès." />
      <meta name="keywords" content="Matching entrepreneurial, Trouver un associé startup, Plateforme pour entrepreneurs, Réseau entrepreneurial, Partenariat startup, Application pour entrepreneurs, Communauté d’entrepreneurs, Association d’entrepreneurs, Création de startup, Collaborateur startup, Networking startup, Recherche co-fondateur, Collaboration entrepreneuriale, Mentor startup, Équipe fondatrice, Levée de fonds startup, Écosystème entrepreneurial, Événements pour entrepreneurs, Gestion de projet startup, Entrepreneuriat digital, Comment trouver un associé pour ma startup, Plateforme de mise en relation pour entrepreneurs, Créer une équipe startup performante, Outils pour startups en phase de lancement, Réseau d’entrepreneurs pour jeunes créateurs, App de matching pour entrepreneurs, Application pour trouver des partenaires business, Innovation entrepreneuriale, Algorithme de matching startup, Solutions innovantes pour startups, Nouveaux modèles d’entrepreneuriat, Startups disruptives, Entrepreneuriat en France, Startup Paris, Écosystème startup européen, Entrepreneurial matching, Find a startup partner, Platform for entrepreneurs, Entrepreneurial network, Startup partnership, App for entrepreneurs, Entrepreneur community, Entrepreneur association, Startup creation, Startup collaborator, Startup networking, Co-founder search, Entrepreneurial collaboration, Startup mentor, Founding team, Startup fundraising, Entrepreneurial ecosystem, Events for entrepreneurs, Startup project management, Digital entrepreneurship, How to find a partner for my startup, Networking platform for entrepreneurs, Create a high-performing startup team, Tools for launching startups, Entrepreneur network for young creators, Matching app for entrepreneurs, App to find business partners, Entrepreneurial innovation, Startup matching algorithm, Innovative solutions for startups, New entrepreneurship models, Disruptive startups, Entrepreneurship in France, Startup Paris, European startup ecosystem" />
      <meta property="og:title" content="Antoo - Trouvez le partenaire idéal pour vos projets" />
      <meta property="og:description" content="Avec Antoo, trouvez le partenaire idéal pour transformer vos idées en succès." />
      <meta property="og:image" content={logo} />
        <script>
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-W5VJLLV5');`}
        </script>
      </Helmet>
      <header className={styles['App-header']} id="top">
        <nav className={styles['App-nav']}>
          <div className={styles['nav-content']}>
            <a href="/" className={styles.logo}>
              <img src={logo} alt="Logo Antoo" />
            </a>
            <a href="#section1" className={styles['nav-item']}>About Us</a>
            <a href="#section2" className={styles['nav-item']}>Solution</a>
            <a href="#section3" className={styles['nav-item']}>Roadmap</a>
            <a href="#section4" className={styles['nav-item']}>Team</a>
            <div className={styles.dropdown}>
              <button onClick={toggleDropdown} className={styles['nav-item']}>
                Community <img src={downArrow} alt="Flèche vers le bas" className={styles['dropdown-arrow']} />
              </button>
              {dropdownOpen && (
                <div className={styles['dropdown-content']}>
                  <a href="https://www.instagram.com/antoo.app/" target="_blank" rel="noopener noreferrer">
                    <img src={instagramLogo} alt="Instagram" className={styles['dropdown-logo']} /> Instagram
                  </a>
                  <a href="https://www.tiktok.com/@antoo_app/" target="_blank" rel="noopener noreferrer">
                    <img src={tiktokLogo} alt="Tiktok" className={styles['dropdown-logo']} /> Tiktok
                  </a>
                  <a href="https://www.linkedin.com/company/antoo-app" target="_blank" rel="noopener noreferrer">
                    <img src={linkedinLogo} alt="Linkedin" className={styles['dropdown-logo']} /> Linkedin
                  </a>
                </div>
              )}
            </div>
            <button className={`${styles['action-button']} ${styles['nav-item']}`} onClick={handleButtonClick}>Join Us</button>
          </div>
        </nav>
        <div className={styles.Title}>
          <h1>Your partners at your fingertips</h1>
          <h3>With <span className={styles.highlight}>Antoo</span>, find the <span className={styles.italic}>ideal partner</span> to turn your ideas into success.</h3>
        </div>
        <button className={styles['redirect-button']} onClick={handleButtonClick}>Find a project</button>
        <div className={styles.soutien}>
          <p>Supported by</p>
          <img src={incubateurLogo} alt="Incubateur" />
          <p>Incubator</p>
        </div>
      </header>
      <main>
        <div className={styles['partners-section']}> 
          <h2>Don't wait any longer, become a partner!</h2>
          <button className={styles['contact-button']} onClick={() => window.location.href = 'mailto:partner@antoo.net?subject=%5BCONTACT%20PARTNER%5D%20First%20contact'}>Contact Us</button>
          <div className={styles['image-container']}>
            <img src={epitechLogo} alt="Logo Epitech" className={styles['partner-image']} />
            <img src={neomaLogo} alt="Logo Neoma" className={styles['partner-image']} />
            <img src={CYUniversityLogo} alt="Logo CY University" className={styles['partner-image']} />
          </div>
          <div className={styles['highlight-line']}></div>
        </div>
        <section id="section1">
          <h2 className={styles['section-title']}>About Us</h2>
          <img src={AboutUsStats} alt="About Us Stats" className={styles.AboutUsStatsImage} />
        </section>
        <section id="section2">
          <h2 className={styles['section-title']} style={{marginTop: 40}}>Our Solution</h2>
          <div className={styles['section-content']}>
            <p>A unique application with an innovative matchmaking algorithm to find your ideal partners</p>
            <img src={SolutionImage} alt="Solution Image" />
          </div>
        </section>
        <section id="section3">
          <h2 className={styles['section-title']}>Antoo's Roadmap</h2>
          <div>
            <ProgressBar steps={steps} />
          </div>
        </section>
        <section id="section4">
          <h2 className={styles['section-title']}>Our Team</h2>
          <div className={styles['team-container']}>
            <div className={styles['team-member']}>
              <img src={SachaImage} alt="Photo Sacha Mairesse" className={styles['team-photo']} />
              <a href="https://www.linkedin.com/in/sacha-mairesse" className={styles['team-info']} target="_blank" rel="noopener noreferrer">
                <p>Sacha Mairesse</p>
                <p>CEO</p>
              </a>
            </div>
            <div className={styles['team-member']}>
              <img src={BenjiImage} alt="Photo Benjamin" className={styles['team-photo']} />
              <a href="https://www.linkedin.com/in/benjamin-vielcazals-a9a04927b/" className={styles['team-info']} target="_blank" rel="noopener noreferrer">
                <p>Benjamin Vielcazals</p>
                <p>COO</p>
              </a>
            </div>
            <div className={styles['team-member']}>
              <img src={MaxenceImage} alt="Photo Maxence Perronié" className={styles['team-photo']} />
              <a href="https://www.linkedin.com/in/maxence-perroni%C3%A9/" className={styles['team-info']} target="_blank" rel="noopener noreferrer">
                <p>Maxence Perronié</p>
                <p>CTO</p>
              </a>
            </div>
          </div>
        </section>
      </main>
      <footer className={styles['App-footer']}>
        <p>&copy; {new Date().getFullYear()} Antoo. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;